import { ReturnCaseTrackingEventSchema } from "@redotech/returnbear-model/return-case";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const getReturnBearTrackingEvents = {
  name: "getReturnBearTrackingEvents" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({ trackingEvents: z.array(ReturnCaseTrackingEventSchema) }),
};

export type ReturnBearTrackingEvent = z.infer<
  typeof getReturnBearTrackingEvents.output
>["trackingEvents"][number];
